import { render, staticRenderFns } from "./VerifyPhoneNumber.vue?vue&type=template&id=70ec6dee&scoped=true"
import script from "./VerifyPhoneNumber.vue?vue&type=script&lang=js"
export * from "./VerifyPhoneNumber.vue?vue&type=script&lang=js"
import style0 from "./VerifyPhoneNumber.vue?vue&type=style&index=0&id=70ec6dee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ec6dee",
  null
  
)

export default component.exports